import $ from "jquery";
import store from '../../vue/store/index';

export function accordeon(block, speed = 600, heightHeader = 64, widthHideHeader = 768) {

    $(block).each(function () {
        let accordeon = $(this);

        accordeon.find('.accordeon__item').each(function () {
            let accordeonItem = $(this);
            let title = accordeonItem.find('.accordeon__item-title');
            let content = accordeonItem.find('.accordeon__item-content');

            title.click(function () {
                let active = accordeonItem.hasClass('accordeon__item_active');

                if(active){
                    content.slideUp(speed);
                    accordeonItem.removeClass('accordeon__item_active');
                } else {
                    accordeon.find('.accordeon__item_active').each(function () {
                        $(this).find('.accordeon__item-content').slideUp(speed);
                        $(this).removeClass('accordeon__item_active');
                    });
                    content.slideDown(speed, function () {
                        store.dispatch('scrollToElement', {
                            element: document.getElementById(accordeonItem.attr('id')),
                            duration: speed
                        });
                    });
                    accordeonItem.addClass('accordeon__item_active');
                }
            });
        });
    })
}